<div class="issue-card"
     [class.selectable]="showCheckbox()"
     [class.selected]="showCheckbox() && selected()"
     [class.invalid]="invalid()"
     [attr.role]="showCheckbox() ? 'checkbox' : null"
     [attr.tabindex]="showCheckbox() ? 0 : null"
     [attr.aria-checked]="showCheckbox() ? selected() : null"
     (click)="toggleSelected()"
     (keydown.enter)="toggleSelected()"
     (keydown.space)="$event.preventDefault(); toggleSelected()"
     [attr.data-testid]="testId()">

  @if (showCheckbox()) {
    <p-checkbox class="issue-card-checkbox"
                [binary]="true"
                [ngModel]="selected()"
                (onChange)="selected.set($event.checked)"
                (click)="$event.stopPropagation()"
                [attr.data-testid]="testId() + '-checkbox'" />
  }

  <div class="issue-card-body">
    <p class="issue-card-text body-md-regular"
       [attr.data-testid]="testId() + '-text'">{{ issue().text }}</p>

    @if (media().length > 0) {
      <app-assertion-image-gallery [images]="media()"
                                   [readonly]="true"
                                   [thumbnailSize]="64"
                                   [attr.data-testid]="testId() + '-photos'" />
    }
  </div>
</div>
